import React from 'react';
import GaugeComponent from 'react-gauge-component';
import {UserSkill} from '../../../../models';

interface AuraCardProps {
  score: number;
  updatedAt: string;
  userSkills: UserSkill[];
}

export const AuraCard: React.FC<AuraCardProps> = ({score, updatedAt, userSkills}) => (
  <section className="bg-white rounded-2xl px-8 py-6 flex flex-col items-center justify-between shadow-sm w-full max-w-[468px]">
    <div className="relative flex flex-col items-center justify-center mb-3">
      <GaugeComponent
        type="semicircle"
        arc={{
          colorArray: ['#FF2121', '#00FF15'],
          padding: 0.02,
          subArcs: [{limit: 40}, {limit: 60}, {limit: 70}, {}, {}, {}, {}],
        }}
        pointer={{type: 'blob', animationDelay: 0}}
        labels={{
          valueLabel: {
            style: {
              fill: '#0f172a',
            },
          },
        }}
        value={score}
      />

      <div className="text-center mt-1">
        <div className="text-zinc-900 text-base font-bold">Aura Matching Score</div>
        <div className="text-neutral-500 text-xs mt-0.5">Last updated on {updatedAt}</div>
      </div>
    </div>
  </section>
);
